const FEATURED_TAG_RE = /^featured:\s*true$/iu;

/**
 * Whether a model is "featured" — carries the gateway's admin-curated
 * `Featured: True` catalog tag (matched case-insensitively). Featured models
 * form the picker's default list, so the catalog owner controls that list
 * through LiteLLM tags without a UI release. No Featured tag ⇒ not featured,
 * including the whole catalog when the gateway served a fallback source that
 * carries no tags (the picker then falls back to its hand-curated sections).
 */
export function isFeatured(tags: readonly string[] | undefined): boolean {
  if (tags == null) return false;
  return tags.some((tag) => FEATURED_TAG_RE.test(tag.trim()));
}
